/* src/app/components/planestratamiento/solicitarinformacion/solicitarinformacion.component.scss */
/*# sourceMappingURL=solicitarinformacion.component.css.map */
